
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/experiments",
      function () {
        return require("private-next-pages/customer-studio/experiments.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/experiments"])
      });
    }
  